/**
 * Apoio de UI para o Plano de Ação por cargo/setor (Portal da Unidade + gestão
 * de contas `unidade`). Deriva os rótulos e o mapa itemId→setor do catálogo, sem
 * IO — mesma fonte usada pelo recorte no servidor (`setorPorItem`).
 */
import { CATALOGO, SETORES } from "@caint/data";
import type { CargoUnidade } from "@caint/shared";

/** Cargos de uma conta de unidade, na ordem de exibição. */
export const CARGOS_UNIDADE: readonly CargoUnidade[] = ["diretor", "coordenador", "gerente", "supervisor"];

/** Rótulo de cada cargo. O cargo é só identidade — todos veem a unidade inteira. */
export const CARGO_UNIDADE_ROTULO: Record<CargoUnidade, string> = {
  diretor: "Diretor(a)",
  coordenador: "Coordenador(a)",
  gerente: "Gerente",
  supervisor: "Supervisor(a)",
};

/** Setores selecionáveis: código + rótulo "05F · UTI". */
export const SETOR_OPCOES: readonly { code: string; rotulo: string }[] = SETORES.map((s) => ({
  code: s.code,
  rotulo: `${s.code} · ${s.nome}`,
}));

/** Nome do setor por código (05F → "UTI"). */
export const NOME_SETOR: ReadonlyMap<string, string> = new Map(SETORES.map((s) => [s.code, s.nome]));

/** Setor (código 05A..05R) de cada item do catálogo. */
export const SETOR_POR_ITEM: ReadonlyMap<string, string> = new Map(CATALOGO.map((i) => [i.id, i.sector]));

/** Nome só do cargo (sem a dica de escopo): "Coordenador(a)". */
export function nomeCargo(cargo: string | null | undefined): string {
  return cargo ? (CARGO_UNIDADE_ROTULO[cargo as CargoUnidade]?.split(" — ")[0] ?? cargo) : "";
}

/** Descrição curta cargo + setores para listas: "Coordenador(a) · UTI, Núcleos…". */
export function descricaoUnidade(cargo: string | null, setores: readonly string[] | null): string {
  const nome = nomeCargo(cargo);
  if (!nome || cargo === "diretor" || !setores?.length) {
    return nome;
  }
  return `${nome} · ${setores.map((c) => NOME_SETOR.get(c) ?? c).join(", ")}`;
}
